import usePolling from '~/react/hooks/usePolling'
import {useRails} from '~/react/contexts/rails'

export const usePointsBalance = () => {
  const {
    organisation: {currentSupplier},
  } = useRails()

  const supplierId = currentSupplier?.id
  const url = supplierId
    ? `/points/api/suppliers/${supplierId}/points_balance`
    : null
  const {data: balanceData, loading} = usePolling(url, true, 5000)

  const pointsBalance = balanceData?.balance || 0

  return {
    pointsBalance,
    loading,
  }
}
